import React from "react";
import { ArrowRight } from "lucide-react";
import { NLink } from "@/i18n/I18nProvider";
import { TaglineLines } from "@/components/home/SectionTitle";

const HERO_IMAGE = "/hero-northcrest.jpg";

const HeroBackground = () => (
  <div className="absolute inset-0 overflow-hidden">
    <div
      className="absolute inset-0 ken-burns"
      style={{ backgroundImage: `url(${HERO_IMAGE})`, backgroundSize: "cover", backgroundPosition: "center" }}
    />
    <div
      className="absolute inset-0"
      style={{ background: "linear-gradient(rgba(15,27,45,0.78), rgba(15,27,45,0.55) 40%, rgba(15,27,45,0.92))" }}
    />
  </div>
);

const HeroCtas = ({ t }) => (
  <div className="mt-12 flex flex-col sm:flex-row gap-4 fade-up delay-4">
    <NLink
      to="/contact"
      data-testid="hero-cta-primary"
      className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#C4A46A] text-[#0F1B2D] text-[12px] tracking-[0.24em] uppercase font-bold hover:bg-[#A38755] transition-colors"
    >
      {t.home.ctaPrimary} <ArrowRight size={16} />
    </NLink>
    <NLink
      to="/about"
      data-testid="hero-cta-secondary"
      className="inline-flex items-center justify-center gap-3 px-8 py-4 border border-[#C4A46A] text-[#C4A46A] text-[12px] tracking-[0.24em] uppercase font-bold hover:bg-[#C4A46A]/10 transition-colors"
    >
      {t.home.ctaSecondary}
    </NLink>
  </div>
);

export const HomeHero = ({ t }) => (
  <section data-testid="home-hero" className="relative grain min-h-[100svh] flex items-center bg-[#0F1B2D] overflow-hidden">
    <HeroBackground />
    <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 py-24 sm:py-28 lg:py-32 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end w-full">
      <div className="lg:col-span-8 fade-up">
        <span className="gold-rule block" />
        <h1 className="mt-8 font-display text-white text-[2.1rem] sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-normal">
          <span className="block fade-up delay-1">{t.home.heroTitle1}</span>
          <span className="block font-serif-italic text-[#C4A46A] mt-3 fade-up delay-2 text-[2.6rem] sm:text-6xl lg:text-7xl tracking-tight leading-[1]">
            {t.home.heroTitle2}
          </span>
        </h1>
        <p className="mt-10 max-w-xl text-white/80 text-lg leading-relaxed fade-up delay-3">{t.home.heroSubtitle}</p>
        <HeroCtas t={t} />
      </div>
      <div className="lg:col-span-4 hidden lg:block fade-up delay-3">
        <div className="border-l border-[#C4A46A]/40 pl-6">
          <div className="overline text-[#C4A46A]">Northcrest</div>
          <p className="mt-4 font-display text-white text-xl leading-snug"><TaglineLines text={t.common.tagline} /></p>
          <p className="mt-3 text-white/60 text-sm italic">{t.common.taglineSecondary}</p>
        </div>
      </div>
    </div>
  </section>
);
